<template>
  <div class="v-content">
    <author
      v-for="(author, index) in authors"
      :author="author"
      :includes="includes"
      :key="index"/>
    <div class="date">
      {{ publishedDate }}
    </div>
  </div>
</template>

<style scoped>
.v-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.date {
  margin-bottom: 1em;
}
</style>
<script>
import Author from "./author";

export default {
  name: "Authors",
  components: { Author },
  props: {
    authors: {
      type: Array
    },
    includes: {
      type: Object
    },
    publishedDate: {
      type: String
    }
  }
};
</script>

<style scoped>
</style>
